import React from 'react';
import styles from './StanDivider.module.css';
import { StanDividerProps } from '../types';

export const StanDivider: React.FC<StanDividerProps> = ({ label, padded = false, thick = false, className = '' }) => {
    const paddedClass = padded ? styles.padded : '';
    const thickClass = thick ? styles.thick : '';

    if (label) {
        return (
            <div className={`${styles.labeled} ${paddedClass}`.trim()}>
                <hr className={`${styles.divider} ${thickClass} ${className}`.trim()} />
                <span className={`text-xs font-semibold ${styles.label}`}>{label}</span>
                <hr className={`${styles.divider} ${thickClass} ${className}`.trim()} />
            </div>
        );
    }
    return <hr className={`${styles.divider} ${paddedClass} ${thickClass} ${className}`.trim()} />;
};

export default StanDivider;
